(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    (function() {
    const collapsibleContainer = document.querySelector('[data-collapsible-description]');
    
    if (!collapsibleContainer) return;
    
    const content = collapsibleContainer.querySelector('[data-description-content]');
    const toggleButton = collapsibleContainer.querySelector('[data-toggle-button]');
    const toggleText = collapsibleContainer.querySelector('[data-toggle-text]');
    
    if (!content || !toggleButton) return;
    
    let isExpanded = false;
    const collapsedHeight = 120; // matches CSS max-height
    const fullHeight = content.scrollHeight;
    
    // If content is shorter than collapsed height, hide toggle button
    if (fullHeight <= collapsedHeight) {
      toggleButton.style.display = 'none';
      content.style.maxHeight = 'none';
      return;
    }
    
    // Set initial state
    content.style.maxHeight = collapsedHeight + 'px';
    
    // Toggle function
    function toggleDescription() {
      isExpanded = !isExpanded;
      
      if (isExpanded) {
        content.style.maxHeight = fullHeight + 'px';
        toggleButton.setAttribute('aria-expanded', 'true');
        if (toggleText) {
          const readLessText = '{{ "products.product.read_less" | t | default: "Weniger anzeigen" }}';
          toggleText.textContent = readLessText;
        }
      } else {
        content.style.maxHeight = collapsedHeight + 'px';
        toggleButton.setAttribute('aria-expanded', 'false');
        if (toggleText) {
          const readMoreText = '{{ "products.product.read_more" | t | default: "Mehr lesen" }}';
          toggleText.textContent = readMoreText;
        }
      }
      
      // Remove gradient fade when expanded
      if (isExpanded) {
        content.classList.add('is-expanded');
      } else {
        content.classList.remove('is-expanded');
      }
    }
    
    // Add click event listener
    toggleButton.addEventListener('click', toggleDescription);
    
    // Handle window resize - recalculate full height
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        const newFullHeight = content.scrollHeight;
        if (isExpanded) {
          content.style.maxHeight = newFullHeight + 'px';
        }
      }, 150);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
